import React, { useState } from 'react';
import { Loader2, Mail, MapPin, Phone } from 'lucide-react';
import { site } from '../data/site';
type Status = 'idle' | 'submitting' | 'success' | 'error';
export function Contact() {
  const [status, setStatus] = useState<Status>('idle');
  const [form, setForm] = useState({
    name: '',
    contact: '',
    details: ''
  });
  const update = (field: keyof typeof form) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setForm(prev => ({
    ...prev,
    [field]: event.target.value
  }));
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!form.name.trim() || !form.contact.trim()) {
      setStatus('error');
      return;
    }
    setStatus('submitting');
    window.setTimeout(() => {
      setStatus('success');
      setForm({
        name: '',
        contact: '',
        details: ''
      });
    }, 900);
  };
  return <section id="contact" className="w-full bg-white" data-id="element-8" data-mp="bpm90b1x16t5">
      <div className="mx-auto grid w-full max-w-6xl gap-14 px-6 py-20 md:py-28 lg:grid-cols-2" data-id="element-9" data-mp="bo1j4yqjqc1m">
        <div data-id="element-10" data-mp="3jw4hlyi93gyw">
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-[#1D4ED8]" data-id="element-11" data-mp="3jxo07vrdq43u">
            Contact
          </p>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-[#0B2A6B] sm:text-4xl" data-id="element-12" data-mp="3b39aez983b6h">
            Request a free quote
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-slate-600" data-id="element-13" data-mp="3f3jrp82gto0n">
            Tell us a little about your property and {site.owner} will get back to you with a
            flat price.
          </p>

          <dl className="mt-10 space-y-4 border-t border-sky-100 pt-8" data-id="element-14" data-mp="365r8hstmhw7z">
            <div className="flex items-center gap-3" data-id="element-15" data-mp="2s5gkcxjp6vqi">
              <dt className="sr-only" data-id="element-16" data-mp="2s6rjul641hbt">Phone</dt>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-50" data-id="element-17" data-mp="2w71qm01q8brq">
                <Phone className="h-4 w-4 text-[#1D4ED8]" aria-hidden="true" data-id="element-18" data-mp="qe3h0cxdovwk" />
              </span>
              <dd data-id="element-19" data-mp="udm1j7laf4yv">
                <a href={site.phoneHref} className="text-sm text-[#0B2A6B] hover:underline" data-id="element-20" data-mp="ue3vfxkh973m">
                  {site.phone}
                </a>
              </dd>
            </div>
            <div className="flex items-center gap-3" data-id="element-21" data-mp="1ybfw2uu1m8f7">
              <dt className="sr-only" data-id="element-22" data-mp="1uaw2204rnkxa">Email</dt>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-50" data-id="element-23" data-mp="1uboz29dxaw28">
                <Mail className="h-4 w-4 text-[#1D4ED8]" aria-hidden="true" data-id="element-24" data-mp="1pd4aj781a0tm" />
              </span>
              <dd data-id="element-25" data-mp="2m0s4hshjqcgg">
                <a href={site.emailHref} className="text-sm text-[#0B2A6B] hover:underline" data-id="element-26" data-mp="2m1aa3fq3m311">
                  {site.email}
                </a>
              </dd>
            </div>
            <div className="flex items-center gap-3" data-id="element-27" data-mp="2d8gs3aj9opjh">
              <dt className="sr-only" data-id="element-28" data-mp="28aoo3i5clcyx">Service area</dt>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-sky-50" data-id="element-29" data-mp="28a5hgxl5eb07">
                <MapPin className="h-4 w-4 text-[#1D4ED8]" aria-hidden="true" data-id="element-30" data-mp="35rm1n0eopehx" />
              </span>
              <dd className="text-sm text-[#0B2A6B]" data-id="element-31" data-mp="30xrlg6yafhnl">{site.location}</dd>
            </div>
          </dl>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 rounded-sm border border-sky-100 bg-sky-50/50 p-8" noValidate data-id="element-32" data-mp="38clfghxk0aku">
          <div data-id="element-33" data-mp="3i7lod97m1uop">
            <label htmlFor="name" className="block text-xs uppercase tracking-[0.18em] text-[#1D4ED8]" data-id="element-34" data-mp="3i73lhtqg0i7t">
              Name
            </label>
            <input id="name" name="name" value={form.name} onChange={update('name')} className="mt-2 w-full border-b border-sky-200 bg-transparent py-3 text-sm text-[#0B2A6B] outline-none transition-colors placeholder:text-slate-400 focus:border-[#1D4ED8]" placeholder="Your name" data-id="element-35" data-mp="3r9ctocy8nzi1" />
          </div>

          <div data-id="element-36" data-mp="dugk7c17c89d">
            <label htmlFor="contact" className="block text-xs uppercase tracking-[0.18em] text-[#1D4ED8]" data-id="element-37" data-mp="duyomvy0pssd">
              Phone or email
            </label>
            <input id="contact" name="contact" value={form.contact} onChange={update('contact')} className="mt-2 w-full border-b border-sky-200 bg-transparent py-3 text-sm text-[#0B2A6B] outline-none transition-colors placeholder:text-slate-400 focus:border-[#1D4ED8]" placeholder="How should we reach you?" data-id="element-38" data-mp="itt7tyzwdjd0" />
          </div>

          <div data-id="element-39" data-mp="3idcmt30e6d6g">
            <label htmlFor="details" className="block text-xs uppercase tracking-[0.18em] text-[#1D4ED8]" data-id="element-40" data-mp="3id2z5m2tki3x">
              Details
            </label>
            <textarea id="details" name="details" rows={4} value={form.details} onChange={update('details')} className="mt-2 w-full resize-none border-b border-sky-200 bg-transparent py-3 text-sm text-[#0B2A6B] outline-none transition-colors placeholder:text-slate-400 focus:border-[#1D4ED8]" placeholder="Home or business, number of windows, timing" data-id="element-41" data-mp="3edc0yxayqzpd" />
          </div>

          {status === 'error' && <p role="alert" className="text-sm text-red-600" data-id="element-42" data-mp="2klxvxrhkagc4">
              Please add your name and a way to reach you.
            </p>}
          {status === 'success' && <p role="status" className="text-sm text-[#1D4ED8]" data-id="element-43" data-mp="2bkzn8vw6hkn7">
              Thanks — your request is in. We&apos;ll be in touch shortly.
            </p>}

          <button type="submit" disabled={status === 'submitting'} className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1D4ED8] px-7 py-3.5 text-sm font-medium text-white transition-colors hover:bg-[#0B2A6B] disabled:opacity-60" data-id="element-44" data-mp="348vidw63n4hv">
            {status === 'submitting' && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-45" data-mp="2zezrfdo96hw7" />}
            {status === 'submitting' ? 'Sending' : 'Send request'}
          </button>
        </form>
      </div>
    </section>;
}